import { RichUtils, KeyBindingUtil, EditorState } from "draft-js";
import * as React from 'react';
import { PALETTE } from '../../../common/styles/palette';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
	return {
		customStyleMap: {
			HIGHLIGHT: {
				background: PALETTE.UI.RichTextEditor.HighLight.Background
			}
		},
		keyBindingFn: (e:React.KeyboardEvent) => {
			if (KeyBindingUtil.hasCommandModifier(e)  && e.key === "h") {
				return "highlight";
			}
		},
		handleKeyCommand: (command:string, editorState:EditorState, other:any) => {
			if (command === "highlight") {
				other.setEditorState(RichUtils.toggleInlineStyle(editorState, "HIGHLIGHT"));
				return true;
			}
		}
	};
};